// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import Icon from '@atlaskit/icon';
import AutomationIcon from '@atlaskit/icon/core/automation';
import { token } from '@atlaskit/tokens';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';

export const AutomationGlyph = (props: ComponentProps<'svg'>): React.JSX.Element => (
	<svg
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
	>
		<path d="M14 5L10 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
		<path
			d="M14 5L7 12H17L10 19"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const AutomationLegacyIcon = (): React.JSX.Element => (
	// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
	<Icon glyph={AutomationGlyph} label="" primaryColor={token('color.icon.brand')} />
);

export default componentWithFG(
	'enghealth-custom-icon-migration',
	AutomationIcon,
	AutomationLegacyIcon,
);
